<template>
  <div class="auth-page">
    <div class="app flex-row align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="px-5 py-3">
              <b-img
                width="325"
                fluid
                block
                center
                src="/img/ccpl_logo.png"/>
            </div>
            <div class="card-group">
              <div class="card p-4 bg-light">
                <div class="card-body">
                  <router-view/>
                </div>
                <div class="card-footer text-muted">
                  <span class="float-left">&copy; {{ year }} Carclub Pte Ltd.</span>
                  <span class="float-right">{{ appVersion }}</span>
                </div>
              </div>
              <div
                class="card text-white bg-success py-5 d-md-down-none border-0"
                style="width:44%">
                <div class="card-body text-center">
                  <div class="row align-items-center">
                    <div class="col text-light mx-auto">
                      <i class="fa fa-user-circle fa-5x mt-4"/>
                      <h5 class="mt-3">Employee Single Sign-On</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AuthContainer',
  data () {
    return {
      appVersion: `v${process.env.VUE_APP_VERSION}`,
      year: new Date().getFullYear()
    }
  }
}
</script>
